import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Stack } from '@mui/material'
import NumberFormat from 'react-number-format'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
// import Swal from 'sweetalert2'
// import ReactTooltip from 'react-tooltip'
// import ExitIcon from '@material-ui/icons/ExitToApp'
// import { useHistory } from 'react-router-dom'
import { Table17 } from './Tables/TableSec1/Table17'
import { Table13 } from './Tables/TableSec1/Table13'
import { useFormik } from 'formik'
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import { useAsistencia } from '../../../../context/AsistenciaContext'
import { useAuthentication } from '../../../../context/authenticationContext'
import { useFormTechnicalAssistance } from '../../../../context/TechnicalAssistanceContext'
import { getTechnicalAssistanceFullForm } from '../../../../services/AsistenciaTecnica/get'

export const AsistenciaSeccion1View = (props) => {
  // const history = useHistory()
  const { goToStep, idForm } = props
  const [, dispatch, , setEnableSec3] = useAsistencia()
  const { userCountry, userIDB2C, IdIFIToken } = useAuthentication()
  const { assistanceForm, setAssistanceForm } = useFormTechnicalAssistance()
  const [editableCode, setEditableCode] = useState('')
  const [phone, setPhone] = useState(userCountry === '7' ? '1809' : '')
  const [backup, setBackup] = useState('')
  const [loading, setLoading] = useState(true)

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  const getFullFormTechnicalAssistance = async (idForm) => {
    try {
      const response = await getTechnicalAssistanceFullForm(idForm)
      if (response.Success) setAssistanceForm(response.Data)
      setLoading(false)
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (idForm !== 0) {
      getFullFormTechnicalAssistance(idForm)
    } else setLoading(false)
  }, [])

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdBeneficiaryType: assistanceForm.IdBeneficiaryType || 1,
      IdTechnicalAssistanceType: assistanceForm.IdTechnicalAssistanceType || 4,
      IFICountry: assistanceForm.IFICountry || '',
      IdCurrency: assistanceForm.IdCurrency || null,
      ContactPhoneNumber: assistanceForm.ContactPhoneNumber || '',
      ContactEmail: assistanceForm.ContactEmail || '',
      ContactAdress: assistanceForm.ContactAdress || '',
      TechnicalAssistanceReceivedNumber:
        assistanceForm.TechnicalAssistanceReceivedNumber || 0,
      Draft: assistanceForm.Draft || true,
      IdTechnicalAssistanceAnswer:
        assistanceForm.IdTechnicalAssistanceAnswer || 0,
      IdUserAzureB2C: userIDB2C,
      IdIFI: assistanceForm.IdIFI || IdIFIToken,
      IdForm: assistanceForm.IdForm || 0,
      IfiBenefitCharge: assistanceForm.IfiBenefitCharge || false,
      MipymeDeclares: assistanceForm.MipymeDeclares || false,
      UnderConditions: assistanceForm.UnderConditions || false,
      IdCountry: assistanceForm.IdCountry || Number(userCountry),
      RequestedAmount: assistanceForm.RequestedAmount || null,
      NumberOfApplicants: assistanceForm.NumberOfApplicants || 1,
      ATPDesign: assistanceForm.ATPDesign || false,
      ATPEvaluationsEnvironment:
        assistanceForm.ATPEvaluationsEnvironment || false,
      ATPFinancialAndEconomicEvaluations:
        assistanceForm.ATPFinancialAndEconomicEvaluations || false,
      ATPFeasibilityStudies: assistanceForm.ATPFeasibilityStudies || false,
      ATPBusinessPlanSupport: assistanceForm.ATPBusinessPlanSupport || false,
      ATPSupportResourcesWomen:
        assistanceForm.ATPSupportResourcesWomen || false,
      ATPOther: assistanceForm.ATPOther || false,
      ATPOtherDescription: assistanceForm.ATPOtherDescription || '',
      CCMConstructionClimateChange:
        assistanceForm.CCMConstructionClimateChange || false,
      CCMOrganizationalSkills: assistanceForm.CCMOrganizationalSkills || false,
      CCMGenderRelatedSkills: assistanceForm.CCMGenderRelatedSkills || false,
      CCMOther: assistanceForm.CCMOther || false,
      CCMImplementationProcessesClimateChange:
        assistanceForm.CCMImplementationProcessesClimateChange || false,
      CCMOtherDescription: assistanceForm.CCMOtherDescription || '',
      CCIClimateChangeAdaptation:
        assistanceForm.CCIClimateChangeAdaptation || false,
      CCIClimateChange: assistanceForm.CCIClimateChange || false,
      CCIGenderRelatedSkillsTraining:
        assistanceForm.CCIGenderRelatedSkillsTraining || false,
      CCIFinancialProductDesign:
        assistanceForm.CCIFinancialProductDesign || false,
      CCIEvaluationCriteriaAnalysis:
        assistanceForm.CCIEvaluationCriteriaAnalysis || false,
      CCIMonitoringEvaluation: assistanceForm.CCIMonitoringEvaluation || false,
      CCIOther: assistanceForm.CCIOther || false,
      CCIOtherDescription: assistanceForm.CCIOtherDescription || '',
      Validate: false,
      validateTable17: false,
      NameIFI: assistanceForm.IfiBusinessName || '',
    },
    onSubmit: (values) => {},
  })

  useEffect(() => {
    if (assistanceForm && assistanceForm.ContactPhoneNumber) {
      setPhone(assistanceForm.ContactPhoneNumber)
      formik.setFieldValue(
        'ContactPhoneNumber',
        assistanceForm.ContactPhoneNumber,
      )
    }
  }, [assistanceForm])

  useEffect(() => {
    if (formik.values.IdBeneficiaryType === 2) {
      setEnableSec3(true)
    } else setEnableSec3(false)
  }, [formik.values.IdBeneficiaryType])

  const handleEdit = (e) => {
    if (phone !== '') {
      setBackup(phone)
    } else {
      setBackup('')
    }

    if (e.key === 'Backspace' && phone.length <= 4) {
      setEditableCode(false)
    } else {
      setEditableCode(true)
    }
  }

  useEffect(() => {
    if (backup) {
      if (phone === '' || phone.charAt(0) !== '1' || phone.length < 4) {
        setPhone(backup)
        formik.setFieldValue('companyPhone', backup)
      }
    }
  }, [phone])

  // const cancelForm = () => {
  //   Swal.fire({
  //     title: '¿Estás seguro?',
  //     text: 'Se perderán los datos no guardados',
  //     icon: 'error',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Entendido',
  //     cancelButtonText: 'Cancelar',
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       history.push('/')
  //       dispatch({ type: 'SET_STATE', payload: 1 })
  //     }
  //   })
  // }

  useEffect(() => {
    if (!loading)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
  }, [loading])

  return (
    <>
      {!loading ? (
        <div>
          {/* <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                data-for="exitPop"
                onClick={() => cancelForm()}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>
          </Grid> */}
          <form id="transfers-form">
            <Grid item xs={12} sm={12} md={12}>
              <h1 className="h1text">Información sobre el Beneficiario</h1>
              <br />
            </Grid>

            <Grid container spacing={1}>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1. Tipo de Beneficiario{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <RadioGroup
                      id="TypeBeneficiary"
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      row
                      value={formik.values.IdBeneficiaryType}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio />}
                        label="MIPYME"
                        disabled={true}
                      />
                      <FormControlLabel
                        value={2}
                        control={<Radio />}
                        label="IFI"
                        disabled={true}
                      />
                      <FormControlLabel
                        value={3}
                        control={<Radio />}
                        label="Grupo de MIPYME (Asociaciones, cooperativas, otros)"
                        disabled={true}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    2. Tipo de asistencia técnica{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <RadioGroup
                      id="TypeTechnicalAssistance"
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={formik.values.IdTechnicalAssistanceType}
                    >
                      <FormControlLabel
                        value={4}
                        control={<Radio />}
                        label="Asistencia técnica para pre-inversión de MIPYME"
                        disabled
                      />
                      <FormControlLabel
                        value={5}
                        control={<Radio />}
                        label="Construcción de capacidades para MIPYME"
                        disabled
                      />
                      <FormControlLabel
                        value={3}
                        control={<Radio />}
                        label="Construcción de capacidades para IFI"
                        disabled
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        {/* 3. Nombre(s) del (de los) solicitante(s) */}
                        3. Información de la solicitud
                      </label>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid
                      container
                      spacing={1}
                      className="input__container"
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'end',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={4}>
                        <label>
                          Moneda <span style={{ color: 'red' }}>*</span>
                        </label>
                        <FormControl fullWidth>
                          <TextField
                            id="MiPymeCountry"
                            name="MiPymeCountry"
                            type="text"
                            variant="outlined"
                            sx={{ width: 220 }}
                            disabled
                            value={assistanceForm.NameCurrency}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={4} sm={4} md={4}>
                        <label>
                          Monto solicitado correspondiente a contrapartida
                          CAMBio II <span style={{ color: 'red' }}>*</span>
                        </label>
                        <FormControl fullWidth>
                          <NumberFormat
                            id="numberAss"
                            style={{ width: '100%' }}
                            customInput={TextField}
                            thousandSeparator={true}
                            variant="outlined"
                            allowNegative="false"
                            disabled
                            value={formik.values.RequestedAmount}
                            fixedDecimalScale
                            decimalScale={2}
                          />
                        </FormControl>
                      </Grid>

                      {formik.values.IdBeneficiaryType === 3 ? (
                        <>
                          <Grid item xs={4} sm={4} md={4}>
                            <label>
                              Número de MIPYME{' '}
                              <span style={{ color: 'red' }}>*</span>
                            </label>
                            <FormControl fullWidth>
                              <NumberFormat
                                id="numberAss"
                                style={{ width: '100%' }}
                                customInput={TextField}
                                thousandSeparator={true}
                                variant="outlined"
                                allowNegative="false"
                                value={formik.values.NumberOfApplicants}
                                error={formik.errors.NumberOfApplicants}
                                decimalScale={0}
                                inputProps={{ maxLength: 3 }}
                                disabled
                              />
                            </FormControl>
                          </Grid>
                          <label
                            style={{
                              color: 'gray',
                              fontSize: '13px',
                              marginLeft: '68%',
                            }}
                          >
                            Ingrese al menos dos MIPYME
                          </label>
                        </>
                      ) : null}

                      <Grid container spacing={1} className="input__container">
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          style={{ marginBottom: '2%' }}
                        >
                          <label>
                            Nombre(s) del (de los) solicitante(s)
                            <span style={{ color: 'red' }}>*</span>
                          </label>
                        </Grid>
                      </Grid>

                      {formik.values.IdBeneficiaryType !== 2 ? (
                        <Grid item xs={12} sm={12} md={12}>
                          <Table13
                            IdBeneficiaryType={formik.values.IdBeneficiaryType}
                            IdTechnicalAssistanceType={
                              formik.values.IdTechnicalAssistanceType
                            }
                            IdCurrency={formik.values.IdCurrency}
                            IdTechnicalAssistanceAnswer={
                              formik.values.IdTechnicalAssistanceAnswer
                            }
                            RequestedAmount={formik.values.RequestedAmount}
                            NumberOfApplicants={
                              formik.values.NumberOfApplicants
                            }
                            formik={formik.setFieldValue}
                          />
                        </Grid>
                      ) : (
                        <Grid
                          container
                          spacing={1}
                          className="input__container"
                        >
                          <Grid item xs={12} sm={12} md={12}>
                            <label className="responsiveLabel">
                              Institución Financiera
                            </label>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormControl style={{ width: '100%' }}>
                              <TextField
                                id="MiPymeCountry"
                                name="MiPymeCountry"
                                type="text"
                                variant="outlined"
                                sx={{ width: 220 }}
                                disabled
                                value={formik.values.NameIFI}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">4. País</label>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Stack noValidate spacing={3}>
                    <TextField
                      id="MiPymeCountry"
                      name="MiPymeCountry"
                      type="text"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={formik.values.IFICountry}
                    />
                  </Stack>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">5. Datos del contacto</label>
              </Grid>

              <Grid item xs={4} sm={4} md={4}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Número de teléfono fijo o celular
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <FormControl fullWidth>
                  {/* <TextField
                id="IdCurrencyUser"
                name="IdCurrencyUser"
                style={{ width: '100%' }}
                variant="outlined"
                value={formik.values.ContactPhoneNumber}
                onChange={(e) => {
                  formik.setFieldValue('ContactPhoneNumber', e.target.value)
                }}
                error={formik.errors.ContactPhoneNumber}
              />
               */}
                  <PhoneInput
                    id="phone"
                    localization={es}
                    country={
                      userCountry === '1'
                        ? 'cr'
                        : userCountry === '2'
                        ? 'gt'
                        : userCountry === '3'
                        ? 'hn'
                        : userCountry === '4'
                        ? 'ni'
                        : userCountry === '5'
                        ? 'sv'
                        : userCountry === '6'
                        ? 'pa'
                        : userCountry === '7' && 'do'
                    }
                    onlyCountries={
                      userCountry === '1'
                        ? ['cr']
                        : userCountry === '2'
                        ? ['gt']
                        : userCountry === '3'
                        ? ['hn']
                        : userCountry === '4'
                        ? ['ni']
                        : userCountry === '5'
                        ? ['sv']
                        : userCountry === '6'
                        ? ['pa']
                        : userCountry === '7' && ['do']
                    }
                    masks={{
                      pa: '........',
                      hn: '........',
                      ni: '........',
                      gt: '........',
                      cr: '........',
                      sv: '........',
                      do: '(...) ........',
                    }}
                    countryCodeEditable={
                      userCountry !== '7' ? false : editableCode
                    }
                    enableAreaCodes={true}
                    enableAreaCodeStretch
                    areaCodes={{ do: ['809', '829', '849'] }}
                    disableDropdown={userCountry !== '7'}
                    inputProps={{
                      name: 'phone',
                      required: true,
                      autoFocus: true,
                      autoComplete: 'off',
                    }}
                    jumpCursorToEnd={true}
                    inputClass="phone"
                    value={phone}
                    onKeyDown={(e) =>
                      userCountry === '7' ? handleEdit(e) : ''
                    }
                    dropdownClass={userCountry === '7' ? 'dropClass' : ''}
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item xs={8} sm={8} md={8}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Correo electrónico <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <FormControl fullWidth>
                  <TextField
                    id="IdCurrencyUser"
                    name="IdCurrencyUser"
                    style={{ width: '100%' }}
                    variant="outlined"
                    value={formik.values.ContactEmail}
                    error={formik.errors.ContactEmail}
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Dirección <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <FormControl fullWidth>
                  <textarea
                    id="ClimateThreat"
                    placeholder="Dirección"
                    customInput={TextField}
                    value={formik.values.ContactAdress}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        6. Asistencia técnica solicitada{' '}
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    {formik.values.IdTechnicalAssistanceType === 4 ? (
                      <Grid container spacing={1} className="input__container">
                        <Grid item xs={12} sm={12} md={12}>
                          <label className="responsiveLabel">
                            Seleccione la acción correspondiente, solicitada por
                            medio de la asistencia técnica.
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <label
                            className="responsiveLabel"
                            style={{ 'text-decoration': 'underline' }}
                          >
                            Asistencias técnicas para preinversión
                          </label>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="ATPDesign"
                                    checked={!!formik.values.ATPDesign}
                                  />
                                }
                                label="Diseño finales de proyectos de adaptación"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="ATPEvaluationsEnvironment"
                                    checked={
                                      !!formik.values.ATPEvaluationsEnvironment
                                    }
                                  />
                                }
                                label="Evaluaciones / Análisis ambientales"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="ATPFinancialAndEconomicEvaluations"
                                    checked={
                                      !!formik.values
                                        .ATPFinancialAndEconomicEvaluations
                                    }
                                  />
                                }
                                label="Evaluaciones financieras y económicas"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="ATPFeasibilityStudies"
                                    checked={
                                      !!formik.values.ATPFeasibilityStudies
                                    }
                                  />
                                }
                                label="Estudios de factibilidad"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="ATPBusinessPlanSupport"
                                    checked={
                                      !!formik.values.ATPBusinessPlanSupport
                                    }
                                  />
                                }
                                label="Apoyo al diseño final de plan de negocio, para obtener el préstamo "
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="ATPSupportResourcesWomen"
                                    checked={
                                      !!formik.values.ATPSupportResourcesWomen
                                    }
                                  />
                                }
                                label="Recursos  para apoyar a las mujeres en el campo y facilitar su participación en las actividades del programa"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="ATPOther"
                                    checked={!!formik.values.ATPOther}
                                  />
                                }
                                label="Otra: Especifique"
                              />
                            </FormGroup>
                          </Grid>
                          {formik.values.ATPOther && (
                            <Grid
                              container
                              spacing={1}
                              className="input__container"
                            >
                              <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={12}>
                                  <FormControl style={{ width: '100%' }}>
                                    <TextField
                                      id="Others94"
                                      style={{ width: '100%' }}
                                      // error={!!formik.errors.ATPOtherDescription}
                                      variant="outlined"
                                      disabled
                                      value={formik.values.ATPOtherDescription}
                                    />
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    ) : null}
                    {formik.values.IdTechnicalAssistanceType === 5 ? (
                      <Grid container spacing={1} className="input__container">
                        <Grid item xs={12} sm={12} md={12}>
                          <label className="responsiveLabel">
                            Seleccione la acción correspondiente, solicitada por
                            medio de la asistencia técnica.
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <label
                            className="responsiveLabel"
                            style={{ 'text-decoration': 'underline' }}
                          >
                            Construcción de capacidades para MIPYME
                          </label>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCMConstructionClimateChange"
                                    checked={
                                      !!formik.values
                                        .CCMConstructionClimateChange
                                    }
                                  />
                                }
                                label="Construcción de capacidades sobre medidas de adaptación al cambio climático"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCMOrganizationalSkills"
                                    checked={
                                      !!formik.values.CCMOrganizationalSkills
                                    }
                                  />
                                }
                                label="Construcción de capacidades sobre habilidades organizacionales"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCMGenderRelatedSkills"
                                    checked={
                                      !!formik.values.CCMGenderRelatedSkills
                                    }
                                  />
                                }
                                label="Construcción de capacidades en temáticas de género."
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCMImplementationProcessesClimateChange"
                                    checked={
                                      !!formik.values
                                        .CCMImplementationProcessesClimateChange
                                    }
                                  />
                                }
                                label="Procesos de implementación para certificaciones de cambio climático (ejem. Biodiversity check, Economía Azul, Bandera Azul, Q de Calidad...)"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCMOther"
                                    checked={!!formik.values.CCMOther}
                                  />
                                }
                                label="Otra: Especifique"
                              />
                            </FormGroup>
                          </Grid>
                          {formik.values.CCMOther && (
                            <Grid
                              container
                              spacing={1}
                              className="input__container"
                            >
                              <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={12}>
                                  <FormControl style={{ width: '100%' }}>
                                    <TextField
                                      id="Others94"
                                      style={{ width: '100%' }}
                                      variant="outlined"
                                      disabled
                                      value={formik.values.CCMOtherDescription}
                                      error={formik.errors.CCMOtherDescription}
                                    />
                                    {formik.errors.CCMOtherDescription ? (
                                      <div
                                        style={{
                                          color: 'red',
                                          marginTop: '3px',
                                          fontSize: '13px',
                                        }}
                                      >
                                        {formik.errors.CCMOtherDescription}
                                      </div>
                                    ) : null}
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    ) : null}

                    {formik.values.IdTechnicalAssistanceType === 3 ? (
                      <Grid container spacing={1} className="input__container">
                        <Grid item xs={12} sm={12} md={12}>
                          <label className="responsiveLabel">
                            Seleccione la acción correspondiente, solicitada por
                            medio de la asistencia técnica.
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <label
                            className="responsiveLabel"
                            style={{ 'text-decoration': 'underline' }}
                          >
                            Construcción de capacidades para IFI.
                          </label>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCIClimateChangeAdaptation"
                                    checked={
                                      !!formik.values.CCIClimateChangeAdaptation
                                    }
                                  />
                                }
                                label="Adaptación al cambio climático, y evaluación de riesgos ambientales y sociales, para el equipo interno de la IFI"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCIClimateChange"
                                    checked={!!formik.values.CCIClimateChange}
                                  />
                                }
                                label="Construcción de programas de adaptación al cambio climático, inherentes a la IFI"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCIGenderRelatedSkillsTraining"
                                    checked={
                                      !!formik.values
                                        .CCIGenderRelatedSkillsTraining
                                    }
                                  />
                                }
                                label="Capacitación en temáticas de género para las IFI"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCIFinancialProductDesign"
                                    checked={
                                      !!formik.values.CCIFinancialProductDesign
                                    }
                                  />
                                }
                                label="Diseño de productos financieros ad-hoc, para atender inversiones relacionadas con la adaptación al cambio climático"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCIEvaluationCriteriaAnalysis"
                                    checked={
                                      !!formik.values
                                        .CCIEvaluationCriteriaAnalysis
                                    }
                                  />
                                }
                                label="Análisis de criterios de evaluación de inversiones para la introducción de medidas de adaptación al cambio climático"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    value="CCIMonitoringEvaluation"
                                    checked={
                                      !!formik.values.CCIMonitoringEvaluation
                                    }
                                  />
                                }
                                label="Monitoreo y evaluación de inversiones"
                              />
                              <FormControlLabel
                                control={<Checkbox disabled value="CCIOther" />}
                                label="Otra: Especifique"
                                checked={!!formik.values.CCIOther}
                              />
                            </FormGroup>
                          </Grid>
                          {formik.values.CCIOther && (
                            <Grid
                              container
                              spacing={1}
                              className="input__container"
                            >
                              <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={12}>
                                  <FormControl style={{ width: '100%' }}>
                                    <TextField
                                      id="Others94"
                                      style={{ width: '100%' }}
                                      variant="outlined"
                                      disabled
                                      value={formik.values.CCIOtherDescription}
                                    />
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    ) : null}
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Grid item xs={12} sm={12} md={12}>
                  <label
                    className="responsiveLabel"
                    style={{
                      fontWeight: 500,
                      fontSize: '1.05rem',
                      color: '#3f4254',
                    }}
                  >
                    7. Asistencia técnica recibida en los últimos 5 años{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Describa las diferentes asistencias técnicas recibidas en
                      los últimos 5 años, incluyendo las financiadas por el
                      BCIE, ONG u otras instituciones, así como las asistencias
                      técnicas privadas que haya contratado
                    </label>
                  </Grid>

                  <Grid item xs={4} sm={4} md={4} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Número de asistencias técnicas{' '}
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="numberAss"
                        style={{ width: '100%' }}
                        customInput={TextField}
                        thousandSeparator={true}
                        variant="outlined"
                        allowNegative="false"
                        value={formik.values.TechnicalAssistanceReceivedNumber}
                        disabled
                        inputProps={{ maxLength: 3 }}
                        decimalScale={0}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Table17
                      TechnicalAssistanceReceivedNumber={
                        formik.values.TechnicalAssistanceReceivedNumber
                      }
                      IdTechnicalAssistanceAnswer={
                        formik.values.IdTechnicalAssistanceAnswer
                      }
                      formik={formik.setFieldValue}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled
                        value="IfiBenefitCharge"
                        checked={!!formik.values.IfiBenefitCharge}
                      />
                    }
                    label={
                      <>
                        Declaro que nosotros como Institución Financiera no
                        cobramos a la MIPYME por este beneficio.{''}
                        <span style={{ color: 'red' }}>*</span>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled
                        value="MipymeDeclares"
                        checked={!!formik.values.MipymeDeclares}
                      />
                    }
                    label={
                      <>
                        Declaro que la MIPYME no recibe apoyo para la ejecución
                        de la parte de la asistencia técnica solicitada a CAMBIO
                        II, por parte de ninguna otra institución.{''}
                        <span style={{ color: 'red' }}>*</span>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled
                        value="UnderConditions"
                        checked={!!formik.values.UnderConditions}
                      />
                    }
                    label={
                      <>
                        Bajo los requisitos de crédito de la Institución
                        Financiera, la MIPYME es elegible para recibir
                        financiamiento.{''}
                        <span style={{ color: 'red' }}>*</span>
                      </>
                    }
                  />
                </FormGroup>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="general_button">
              <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
                <Button
                  type="button"
                  onClick={() => next()}
                  className="button__wizard button__next"
                >
                  Siguiente
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}
